import React from 'react';

import PropTypes from 'prop-types';

import Select from 'react-select';

const MultiSelect = ({ name, label, options, updateFilters, value, isMulti = true }) => {
  const handleSelect = selectedOption => {
    updateFilters(name, selectedOption);
  };

  const styles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #e3e3e3',
      fontWeight: 100,
      color: '#555',
      backgroundColor: 'white'
    }),
    control: () => ({
      display: 'flex',
      borderRadius: '3px',
      border: '1px solid #333'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color,
      fontSize: state.selectProps.myFontSize
    })
  };

  return (
    <div className="dropdown-main-container">
      <h4 style={{ fontWeight: 'bold' }}>{label}</h4>
      <div className="dropdown-container">
        <Select
          value={value}
          onChange={handleSelect}
          isMulti={isMulti}
          options={options}
          styles={styles}
        />
      </div>
    </div>
  );
};

MultiSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateFilters: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default MultiSelect;
